<kb-tabs *ngIf='alwaysCreateDescriptionTab || 1 < sections.length; else singleSection'>
    <kb-tab *ngFor="let section of sections" [title]="section.title">
        <div class="prose max-w-none mt-6" [innerHTML]="expand ? section.extendedContent || section.content : section.content"></div>
        <button *ngIf='section.extendedContent && section.extendedContent.length > section.content.length && !expand' class='text-link' (click)='expand = true'>Read more...</button>
    </kb-tab>
</kb-tabs>
<ng-template #singleSection>
    <div class="prose max-w-none" [innerHTML]="expand ? sections[0].extendedContent || sections[0].content : sections[0].content"></div>
    <button *ngIf='sections[0].extendedContent && sections[0].extendedContent.length > sections[0].content.length && !expand' class='text-link' (click)='expand = true'>Read more...</button>
</ng-template>
